import './loading-modal.scss';

import LoadingModal from './LoadingModal';

export default LoadingModal;
